module.exports = __webpack_public_path__ + "img/2.a0a1d1ba.png";